<template>
<div class="navbar__container">
  <div class="navbar _flex:justify(space-between) _flex:align(center)" :class="{'_shadow(2)': !showDashboardLink}">
    <div class="_flex:align(center)">
      <span class="navbar__logo">
        <img :src="logo" alt="logo" className="_p:right(2)" />
      </span>
      <router-link v-if="showDashboardLink" class="navbar__link" :to="{ name: 'dashboard' }">
        <ds ds="icon"
          name="prev"
          size="0.75rem"
          color="var(--grey-900)"
        />
        {{ $t('shared.label.dashboard') }}
      </router-link>
    </div>
    <div class="_flex:align(center)">
      <LanguageSelector />
      <ds
        ds="user-menu"
        class="_m:left(3)" v-if="isLoggedIn"
        @signOut="signOut"
        name=""
        wallet=""
        :email="loggedInEmail"
      ></ds>
    </div>
  </div>
   <div  v-if="showDashboardLink" class="navbar navbar__mobile _shadow(2) _m:top(5) ">
    <div class="_flex:align(center)">
      <router-link class="navbar__mobile__link" :to="{ name: 'dashboard' }">
        <ds ds="icon"
          name="prev"
          size="0.75rem"
          color="var(--grey-900)"
        />
        {{ $t('shared.label.dashboard') }}
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import { LanguageSelector } from '@/components';
import { authHelper } from '@/mixins';
import { mapActions, mapGetters } from 'vuex';
const logo = require(`@/assets/themes/${process.env.VUE_APP_THEME_NAME}/logo.png`);

export default {
  name: 'AppIndex',
  mixins: [authHelper],
  components: { LanguageSelector },
  data: () => ({
    logo
  }),
  methods: {
    ...mapActions(
      {
        fetchLanguages: 'qualification/fetchLanguages'
      }
    )
  },
  computed: {
    ...mapGetters(
      {
        languages: 'qualification/languages'
      }),
    showDashboardLink () {
      return this.isLoggedIn && this.$route.name.includes('profile');
    }
  }
};
</script>

<style lang="less">
@import "~@/utils.less";

.navbar {
  width: 100%;
  height: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--white);
  z-index: 3000;
  padding: 0 calc(var(--gw) * 2);
  @media screen and (min-width: 32rem) {
      box-shadow: var(--shadow-2);
    }

  &__container{
    z-index: 3000;
  }

  &__logo {
    display: inline-flex;
    margin-right: calc(var(--gw) * 1.5);

    img {
      max-width: auto;
      max-height: 1.8rem;
    }
  }

  &__link {
    color: var(--grey-900) !important;
    align-items: center;
    vertical-align: bottom;
    padding: 0 calc(var(--gw) / 1.5);
    ._text\:sm;
    @media screen and (max-width: 32rem) {
      display: none;
    }
  }

  &__mobile {
    display: none;
    z-index: 9;
    @media screen and (max-width: 32rem) {
      display: flex;
      align-items: center;
    }

    &__link {
      color: var(--grey-900) !important;
      ._text\:sm;
    }
  }

  ds-icon {
    margin-right: calc(var(--gw) / 2);
  }
}

</style>
